import { render } from "./WorkloadPreApproveDialog.vue?vue&type=template&id=31c58093&scoped=true"
import script from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"
export * from "./WorkloadPreApproveDialog.vue?vue&type=script&lang=js"

import "./WorkloadPreApproveDialog.vue?vue&type=style&index=0&id=31c58093&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31c58093"]])

export default __exports__